import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { ConfirmProvider } from "./components/ConfirmDialog";
import Layout from "./components/Layout";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Home from "./pages/Home";
import ProfilesList from "./pages/ProfilesList";
import ProfileDetail from "./pages/ProfileDetail";
import MyProfile from "./pages/MyProfile";
import CreateProfile from "./pages/CreateProfile";
import Favorites from "./pages/Favorites";
import Messages from "./pages/Messages";
import ChatThread from "./pages/ChatThread";
import Admin from "./pages/Admin";
import "./App.css";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return <div className="min-h-screen flex items-center justify-center text-slate-500">Cargando…</div>;
  }
  if (!user) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function RootRedirect() {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-slate-500">Cargando…</div>;
  if (user) return <Navigate to="/home" replace />;
  return <Landing />;
}

function App() {
  return (
    <AuthProvider>
      <ConfirmProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/home" element={<Protected><Home /></Protected>} />
            <Route path="/profiles/:type" element={<Protected><ProfilesList /></Protected>} />
            <Route path="/profile/create" element={<Protected><CreateProfile /></Protected>} />
            <Route path="/profile/edit/:id" element={<Protected><CreateProfile /></Protected>} />
            <Route path="/profile" element={<Protected><MyProfile /></Protected>} />
            <Route path="/profiles/detail/:id" element={<Navigate to="/" replace />} />
            <Route path="/profiles/id/:id" element={<Protected><ProfileDetail /></Protected>} />
            <Route path="/favorites" element={<Protected><Favorites /></Protected>} />
            <Route path="/messages" element={<Protected><Messages /></Protected>} />
            <Route path="/messages/with/:otherUserId" element={<Protected><ChatThread /></Protected>} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </ConfirmProvider>
    </AuthProvider>
  );
}

export default App;
